import { styled } from '@material-ui/core';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export const MainBody = styled('div')(({ theme }) => ({
  position: 'fixed',
  top: '0px',
  left: '0px',
  width: '100%',
  height: '100%',
  backgroundColor: '#1a1a1a',
  zIndex: 1000,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const LogoCont = styled('div')(({ theme }) => ({
  width: 'auto',
  height: '50px',
  position: 'absolute',
  top: '20px',
  left: '20px',
}));

export const CloseIconCont = styled('div')(({ theme }) => ({
  width: '30px',
  height: '30px',
  position: 'absolute',
  top: '20px',
  right: '20px',
  cursor: 'pointer',
}));

export const VideoCont = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '25vw',
  height: '90vh',
  minWidth: '300px',
  backgroundColor: '#fefefe',
  borderRadius: '10px',
  boxShadow: theme.shadows[10],
  overflow: 'hidden',
}));

export const Video = styled('video')(({ theme }) => ({
  position: 'absolute',
  top: '0px',
  left: '0px',
  height: '100%',
  width: '100%',
  objectFit: 'cover',
}));

export const Img = styled('img')(({ theme }) => ({
  position: 'absolute',
  top: '0px',
  left: '0px',
  height: '100%',
  width: '100%',
  objectFit: 'cover',
}));

export const ProgressBarCont = styled('div')(({ theme }) => ({
  width: 'calc(100% - 20px)',
  height: 'max-content',
  position: 'absolute',
  top: '10px',
  left: '0px',
  display: 'flex',
  justifyContent: 'stretch',
  alignItems: 'center',
  gap: '5px',
  zIndex: 10,
  padding: '10px',
}));

export const Arrow = styled('img')(() => ({
  borderRadius: '50%',
  backgroundColor: 'rgb(41 39 57 / 80%)',
  position: 'absolute',
  top: '50%',
  padding: '7px',
  width: '12px',
  height: '12px',
  cursor: 'pointer',
}));

export const LeftArrow = styled(Arrow)(() => ({
  left: '5px',
  transform: 'rotate(180deg)',
}));

export const RightArrow = styled(Arrow)(() => ({
  right: '5px',
}));

export const UserDetailCont = styled(Box)(() => ({
  position: 'absolute',
  top: '25px',
  left: '0px',
  display: 'flex',
  alignItems: 'center',
  zIndex: 10,
  width: 'calc(100% - 20px)',
  height: 'max-content',
  gap: '5px',
  padding: '10px',
  '& img': {
    width: '45px',
    height: '45px',
  },
}));

export const UsernameText = styled(Typography)(() => ({
  fontWeight: 'lighter',
  color: '#fff',
}));

export const CustomLink = styled(Link)(() => ({
  position: 'absolute',
  top: '100px',
  left: '20px',
  // fontWeight: 'lighter',
  color: '#fff',
  textDecoration: 'none',
}));
